import { gql, useQuery } from '@apollo/client'
import planResult from './planQueryResult'

const useStudentDashboardPlansToComplete = (vars = {}) => {
    return useQuery(
        gql`
        query {
            studentDashboardPlansToComplete {
                ${planResult}
                
            }  
        }`,
        {
            variables: vars,
            fetchPolicy: 'cache-first'
        }
    )
}

export default useStudentDashboardPlansToComplete